import React from "react";
import _ from 'lodash'
import Chart from "react-apexcharts";
import {formattingMoney} from "./utils/formatting";
import {getCurrencySymbol} from "./utils/currency";
import {getTransactionsLabel} from "./utils/transactions";


export default function ChartPortfolio(props) {
    const data = props.data
    const category = props.category
    const series_title = props.series_title
    const currency = props.currency
    const points = props.points || []
    const xaxis = props.xaxis || []

    return (
        <div >
            <div style={{margin: "auto"}}>

                <Chart options={{
                    chart: {
                        id: 'chart',
                        defaultLocale: 'ru',
                        toolbar: {
                            show: true,
                            tools: {
                                download: false,
                                selection: true,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: false
                            }
                        },
                        //defaultLocale: 'ru',
                    },
                    annotations: {
                        yaxis: [{
                            y: data[data.length-1],
                            borderColor: '#999',
                        }],
                        xaxis: xaxis,
                        points: points
                    },
                    dataLabels: {
                        enabled: false
                    },
                    colors: ['#10B981'],
                    toolbar: {
                        show: false,
                        autoSelected: 'selection'
                    },
                    stroke: {
                        width: 2
                    },
                    grid: {
                        borderColor: '#E8ECF2',
                        strokeDashArray: 4,
                        xaxis: { lines: { show: false } },
                        yaxis: { lines: { show: true } },
                    },
                    tooltip: {
                        theme: 'light',
                        style: { fontFamily: '"DM Sans", sans-serif' },
                        x: {
                            format: 'dd MMM yyyy'
                        }
                    },fill: {
                        colors: ['#10B981'],
                        type: 'gradient',
                        gradient: {
                            shadeIntensity: 1,
                            opacityFrom: 0.4,
                            opacityTo: 0.05,
                            stops: [0, 100]
                        }
                    },
                    yaxis: {
                        opposite:true,
                        labels: {
                            formatter: function (value) {
                                return `${formattingMoney(value)} ${currency}`;
                            },
                            style: {
                                fontFamily: '"DM Sans", sans-serif',
                                fontSize: '12px',
                                colors: '#64748B',
                            },
                        },
                    },
                    xaxis: {
                        categories: category,
                        tooltip: {enabled: false},
                        type: 'datetime',
                        labels: {
                            style: {
                                fontFamily: '"DM Sans", sans-serif',
                                fontSize: '12px',
                                colors: '#64748B',
                            },
                        },
                    }


                }}
                       series={[{
                           name: series_title,
                           data: data
                       }]} type="area"  height={300} />
            </div>
        </div>
    );
    // return (
    //   <ChartPortfolioSVG category={graph_title} data={graph} />
    // );
}
